import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, nextTick, watch, PropType } from "vue";
import VerticalSlider from "@/components/shared/VerticalSlider.vue";


const __default__ = {
  name: "RadiusSlider2",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  height: {
    type: String,
    required: true,
  },
  initialRadiusIndex: {
    type: Number,
    default: 0,
  },
  radiusMeterList: {
    type: Array as PropType<number[]>,
    default: () => [],
  },
},
  emits: ["onChangeRadiusMeter"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;
const emit = __emit;

// 0→최대 오름차순
const sortedList = computed(() =>
  [...props.radiusMeterList].sort((a, b) => a - b)
);
const N = computed(() => sortedList.value.length);
// 텍스트는 내림차순(0이 마지막)
const reversedList = computed(() => [...sortedList.value].reverse());

// 선택 인덱스: 0..N-1
const selectedRadiusIndex = ref(props.initialRadiusIndex);
watch(selectedRadiusIndex, (newIdx, oldIdx) => {
  if (newIdx !== oldIdx) {
    emit("onChangeRadiusMeter", sortedList.value[newIdx]);
  }
});

// 레이블·컨테이너 높이 측정
const wrapper = ref<HTMLElement | null>(null);
const textContainer = ref<HTMLElement | null>(null);
const containerHeight = ref(0);
const labelHeight = ref(0);

onMounted(() => {
  nextTick(() => {
    if (wrapper.value) containerHeight.value = wrapper.value.clientHeight;
    if (textContainer.value) {
      const span = textContainer.value.querySelector("span");
      if (span) labelHeight.value = (span as HTMLElement).clientHeight;
    }
  });
});

// filled 높이 계산
const rangeFilledHeight = computed(() => {
  const idx = selectedRadiusIndex.value;

  if (idx === 0) {
    return "0%"; // 꼭바닥
  }
  if (idx === N.value - 1) {
    return "100%"; // 꼭꼭대기
  }

  if (!containerHeight.value || !labelHeight.value || N.value < 2) {
    const raw = (idx / (N.value - 1)) * 100;
    return `${raw}%`;
  }

  const H = containerHeight.value;
  const L = labelHeight.value;
  const gap = (H - L * N.value) / (N.value - 1);
  const labelCenter = L / 2;

  // (N-1-idx)개의 레이블+간격+센터 만큼 빼면
  // bottom 기준 채워질 픽셀 수
  const px =
    H - (L * (N.value - 1 - idx) + gap * (N.value - 1 - idx) + labelCenter);

  return `${px}px`;
});

const displayRadiusText = (m: number) =>
  m === 0 ? "0" : m < 1000 ? `${m}m` : `${m / 1000}km`;

const __returned__ = { props, emit, sortedList, N, reversedList, selectedRadiusIndex, wrapper, textContainer, containerHeight, labelHeight, rangeFilledHeight, displayRadiusText, VerticalSlider }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})